import { defaultTemplateLandscape, defaultTemplatePortrait, InitialState, NewTemplateSetting, Position, Template } from "./templateModels";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: InitialState = {
    currTemplate: defaultTemplateLandscape,
    prevTemplate: defaultTemplateLandscape,
    isTemplateEditor: false,
}

const templateSlice = createSlice({
    name: 'template',
    initialState,
    reducers:{
        setIsTemplateEditor: (state, action: PayloadAction<boolean>) =>{
            state.isTemplateEditor = action.payload
        },        
        setSelectedTemplate(state, action: PayloadAction<Template>){
            setPrevTemplate(state.currTemplate)
            state.currTemplate = action.payload
        },
        resetTemplateLandscape(state){
            state.currTemplate = defaultTemplateLandscape
            state.prevTemplate = defaultTemplateLandscape
        },
        resetTemplatePortrait(state){      
            state.currTemplate = defaultTemplatePortrait
            state.prevTemplate = defaultTemplatePortrait
        },
        setTemplateName(state, action: PayloadAction<string>){
            state.currTemplate.template_name = action.payload
        },
        setPrevTemplate(state, action: PayloadAction<Template>){            
            const tmpl = action.payload
            state.prevTemplate = tmpl
        },
        setTemplate(state, action: PayloadAction<Template>) {            
            const tmpl = action.payload
            // setPrevTemplate(state.currTemplate)
            state.currTemplate = tmpl
        },
        addTemplateNewPosition(state, action: PayloadAction<Position>) {            
            const newPos = action.payload
            setPrevTemplate(state.currTemplate)
            state.currTemplate.positions?.push(newPos)
        },
        updateTemplatePosition(state, action: PayloadAction<Position>) {            
            const updatedPos = (action.payload);
            const posAlias = updatedPos.alias;
            const foundPosition = state.currTemplate.positions?.filter(pos => pos.alias === posAlias)
            if (foundPosition){
                setPrevTemplate(state.currTemplate)

                const tmpArr = state.currTemplate.positions?.filter(pos => pos.alias !== posAlias)   //exclude the foundPosition                
                state.currTemplate.positions =  [   ...(tmpArr? tmpArr: []),   
                                                    updatedPos
                                                ];
                
                // setTemplate(state.currTemplate)
                console.log("state.currTemplate.positions:", state.currTemplate.positions)
            }
        },
        duplicateTemplatePosition(state, action: PayloadAction<string>) {            
            const posId = action.payload
            const foundPosition = state.currTemplate.positions?.filter(pos => pos.alias === posId)
            if (foundPosition){
                setPrevTemplate(state.currTemplate)
                state.currTemplate.positions?.push({
                    ...foundPosition[0],
                    alias: Math.random().toString(9).slice(0,5).replace('0.', '').toUpperCase(),
                })
            }
        },
        removeTemplatePosition(state, action: PayloadAction<string>) {            
            const posId = action.payload
            const newPosList = state.currTemplate.positions?.filter(pos => pos.alias !== posId)
            setPrevTemplate(state.currTemplate)
            state.currTemplate.positions = newPosList
            // setTemplate({...state.currTemplate})
        },
        
    }
})

export default templateSlice.reducer

export const {
    // setTemplateSettings,
    setIsTemplateEditor,
    setSelectedTemplate,
    resetTemplateLandscape,
    resetTemplatePortrait,
    setTemplateName,
    setPrevTemplate,
    setTemplate,
    addTemplateNewPosition,
    updateTemplatePosition,
    duplicateTemplatePosition,
    removeTemplatePosition
} = templateSlice.actions